import { render, staticRenderFns } from "./cfajfm.vue?vue&type=template&id=195c01d9&scoped=true&"
import script from "./cfajfm.vue?vue&type=script&lang=js&"
export * from "./cfajfm.vue?vue&type=script&lang=js&"
import style0 from "./cfajfm.vue?vue&type=style&index=0&id=195c01d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c01d9",
  null
  
)

export default component.exports